import Calendar from './Calendar'

function Single({ selectedDate, onSelectedDatesChange, isOpen, minDate }) {
  const handleDateSelected = ({ selectable, date }) => {
    if (!selectable) {
      return
    }

    onSelectedDatesChange(date ? [date] : [])
  }

  return (
    <Calendar
      selected={selectedDate}
      onDateSelected={handleDateSelected}
      isOpen={isOpen}
      minDate={minDate}
    />
  )
}

export default Single
